import { API_GENERIC_NOTIFICATION_ENDPOINT } from '@/env';
import { provide } from '@/util/container';

import { GENERIC_NOTIFICATION_API_REST_CLIENT, KEYCLOAK } from '.';
import { createRestClient } from '../rest-client/rest-client';

export default provide(GENERIC_NOTIFICATION_API_REST_CLIENT, async (get) => {
  return createRestClient(await get(KEYCLOAK), API_GENERIC_NOTIFICATION_ENDPOINT);
});
